import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';

import { useScopedTranslation } from 'app/hooks/i18n';
import { Pressable, ScrollView } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { ModalTitle } from './components/modal-title';
import type { useLenderNextScreen } from './use-lender-next-screen';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconChevronRight } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
const theme = createDSTheme();
const CONTENT_CONTAINER_STYLE = {
  flexGrow: 1,
  paddingHorizontal: theme.spacing['spacing.general.x4'],
  paddingBottom: theme.spacing['spacing.general.x8'],
};

type LenderNextScreenState = ReturnType<typeof useLenderNextScreen>;

function ChoiceButton({ emoji, label, onPress }: { emoji: string; label: string; onPress: () => void }) {
  const foreground = theme.colors['text.primary'];

  return (
    <Pressable onPress={onPress}>
      <Row
        alignItems="center"
        gap="spacing.general.x4"
        style={{
          backgroundColor: theme.colors.white,
          borderRadius: theme.borderRadii['radius.md'],
          paddingHorizontal: theme.spacing['spacing.general.x4'],
          paddingVertical: theme.spacing['spacing.general.x4'],
        }}
      >
        <Text fontSize={28}>{emoji}</Text>
        <Text flex={1} fontSize={16} fontWeight="700" style={{ color: foreground }}>
          {label}
        </Text>
        <IconChevronRight strokeWidth={ICON_STROKE_WIDTH} size={24} color={foreground} />
      </Row>
    </Pressable>
  );
}

export function LenderNextScreenBody({ close, createOffer, openInspiration }: LenderNextScreenState) {
  const { t } = useScopedTranslation();
  const foreground = theme.colors['text.primary'];

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: theme.colors['surface.tertiary'] }}>
      <ScrollView contentContainerStyle={CONTENT_CONTAINER_STYLE} showsVerticalScrollIndicator={false}>
        <Column alignItems="center" justifyContent="space-between" marginBottom="spacing.general.x8" minHeight={44}>
          <ModalTitle close={close} />
        </Column>

        <Text
          fontWeight="700"
          marginBottom="spacing.general.x12"
          style={{ color: foreground, fontSize: 36, lineHeight: 44 }}
        >
          {t('title')}
        </Text>

        <Column gap="spacing.general.x2">
          <ChoiceButton emoji="🫴" label={t('specificObjectButton')} onPress={createOffer} />
          <ChoiceButton emoji="🙋" label={t('inspirationButton')} onPress={openInspiration} />
        </Column>
      </ScrollView>
    </SafeAreaView>
  );
}
